import { api } from "../../ConsumeApiController"; 
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";

export async function getResourcesByProduct(productId) {
    const route = CompanyRoutes.ProductResources.getByProduct(productId);
    return await api.get(route);
}

export async function assignResourceToProduct(productId, resourceId, type = 'asset') {
    const route = CompanyRoutes.ProductResources.assign;
    const body = {
        product_id: productId,
        type: type,
        resource_id: resourceId
    };
    return await api.post(route, body);
}

export async function removeResourceFromProduct(assignmentId) {
    const route = CompanyRoutes.ProductResources.remove(assignmentId);
    return await api.delete(route);
}